import styled from 'styled-components';

export const DetailNewsWrapper = styled.div`
  padding-top: 120px;
  @media (max-width: 769px) {
    padding-top: 56px;
  }
  .card_news {
    padding: 16px;
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    margin-bottom: 1rem;
    width: max-content;
    max-width: 100%;
    margin-top: 32px;
    min-width: 200px;
    button {
      background: var(--color-1);
      border: none;
      color: #fff;
      display: flex;
      align-items: center;
      width: 28px;
      height: 28px;
      justify-content: center;
      border-radius: 4px;
      &:focus,
      &:focus-visible {
        outline: none;
      }
    }
    .--top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .--titleCard {
      font-size: 20px;
      font-weight: 700;
    }
    .--card-title {
      padding-top: 12px;
      border-top: 1px solid #0000009c;
      margin-top: 16px;
    }
    ul {
      margin-bottom: 0;
      align-items: flex-start !important;
      &.qs-lv-1 {
        padding-left: 0;
        list-style: none;
        display: flex;
        flex-flow: column;
        gap: 4px;
      }
      .--item {
        font-weight: 600;
        position: relative;
        text-decoration: none;
        &::before {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #000;
          position: absolute;
          top: 6px;
          left: -12px;
        }
        span {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        &.pH1 {
          &::before {
            display: none;
          }
        }
        &.pH2 {
          margin-left: 24px;
        }
        &.pH3 {
          margin-left: 48px;
        }
        &.pH4 {
          margin-left: 62px;
        }
        &.pH5 {
          margin-left: 86px;
        }
      }
      a {
        color: #000;
        transition: all 0.15s ease;
        &:hover {
          color: var(--color-4);
        }
      }
      &.qs-lv-2 {
        padding-left: 0;
        margin-left: 1.5rem;
        list-style: disc;
      }
    }
  }
  .dtNewsContent {
    .--img {
      width: 100%;
      height: 470px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .--tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 16px;
      gap: 8px;
      .--item {
        border: 1px solid #cbc9c9;
        padding: 4px 12px;
        border-radius: 12px;
      }
    }
    .--title {
      font-size: 38px;
      font-weight: 600;
      font-weight: 700;
      line-height: 44px;
    }
    .--content {
      padding: 40px 66px;
      background: #ffffff;
      box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      margin: -60px auto 0;
      position: relative;
      z-index: 1;
      width: 80%;
    }
    .--timeCate {
      display: flex;
      margin-top: 16px;
      align-items: center;
      gap: 32px;
      &.after {
        .--cate {
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #000;
            left: calc(100% + 14px);
          }
        }
      }
      .--cate {
        color: var(--color-1);
        font-size: 12px;
        text-transform: uppercase;
        font-weight: 700;
      }
      .--time {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #858585;
      }
    }
    article {
      margin-top: 24px;
    }
    .--backShare {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #e6e6e6;
      padding-top: 16px;
      margin-top: 16px;
    }
    .--back {
      display: flex;
      gap: 8px;
      align-items: center;
      color: #002b22;
      &:hover {
        color: var(--color-1);
      }
    }

    @media (max-width: 769px) {
      .--img {
        height: 300px;
      }
      .--content {
        width: 100%;
        padding: 20px;
      }
      .--title {
        font-size: 24px;
        line-height: normal;
      }
      article {
        margin-top: 24px;
        text-align: justify;
      }
      .--backShare {
        flex-flow: column;
        gap: 16px;
      }
    }
  }
  .dtNewsOther {
    padding: 80px 0;
    .--content {
      width: 80%;
      margin: 0 auto;
    }
    .--listNews {
      &.litle {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 40px;
      }
    }
    .slider {
      position: relative;
      margin-top: 32px;
    }
    .--arrow {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      width: 62px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 62px;
      border-radius: 50%;
      border: 1px dashed #c6c6c6;
      cursor: pointer;
      &.next {
        right: -80px;
      }
      &.prev {
        left: -80px;
      }
    }
    .slick-slide {
      margin: 0 22px;
    }
    .slick-list {
      margin: 0 -22px;
    }
    .slick-track {
      display: flex;
      height: max-content;
    }
    .--item {
      &:hover {
        .--name {
          color: var(--color-4);
        }
      }
    }
    .--img {
      width: 100%;
      aspect-ratio: 16/11;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .--cate {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 700;
      color: var(--color-1);
      margin-top: 24px;
    }
    .--name {
      margin-top: 12px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      color: #212121;
      transition: var(--transition-all);
    }
    article {
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      color: #464646;
      margin-top: 16px;
    }
    .--time {
      display: flex;
      align-items: center;
      gap: 16px;
      color: #464646;
      margin-top: 8px;
    }
    @media (max-width: 769px) {
      overflow: hidden;
      .--content {
        width: 100%;
      }
      .slider {
        display: flex;
        gap: 24px;
        flex-flow: column-reverse;
        margin-top: 12px;
      }
      .slick-slide {
        margin: 0 16px 0 0;
        width: 300px;
      }
      .slick-list {
        margin: 0;
      }
      .--listNews {
        width: 100vw;
        &.litle {
          width: 100%;
          grid-template-columns: repeat(1, 1fr);
        }
      }
      .arrow {
        display: flex;
        gap: 12px;
      }
      .--arrow {
        position: relative;
        top: unset;
        transform: none;
        width: 40px;
        height: 40px;

        &.next {
          right: unset;
        }
        &.prev {
          left: unset;
        }
      }
    }
  }
`;
